export const SetActiveInventory = {
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
        },
    },
    save: {
        success:'수정에 성공했습니다.',
        error: {
            fail: '수정에 실패했습니다.',
        },
    },
    other: {
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        },
    },
}